import { FormikProps, useFormik } from 'formik';
import { getAddPermissionFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { AclAccess, IAcl } from '../../../../types/interfaces/acl';
import { useGetRoles } from '../../../../services/redux/api/rolesApi';
import { usePostPutAclItem } from '../../../../services/redux/api/aclApi';
import { FormikValues } from 'formik/dist/types';
import { useGetAdminUsers } from '../../../../services/redux/api/usersApi';

export function useAddPermissionComponent(onClose: () => void, acl?: IAcl) {
  const { t } = useTranslation();
  const { data: roles } = useGetRoles();
  const { data: adminUsers } = useGetAdminUsers();
  const [postPutAclItem, { isLoading }] = usePostPutAclItem();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddPermissionFormValidation(t),
    initialValues: {
      role: acl?.role || null,
      user: acl?.user || null,
      permission: acl?.permission || '',
      access: acl?.access || AclAccess.ALLOW,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutAclItem({
      id: acl?.id,
      body: {
        roleId: values.role?.id || null,
        userId: values.user?.id || null,
        permission: values.permission,
        access: values.access,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return { formik, roles, isLoading, adminUsers };
}
